import { getDateInFormat } from "@domains/utils/reportDates";
export const openInterestAnalysisStreaming = (data, streaming) => {
    return data === null || data === void 0 ? void 0 : data.map((x) => {
        if (x.symbol) {
            if (x.symbol === streaming.symbol) {
                return Object.assign(Object.assign({}, x), { change: Number(streaming.changePrice), changePercentage: Number(streaming.changePercentage), latestTradingPrice: Number(streaming.curPrice), latestUpdatedTime: streaming.updatedTime, OI: Number(streaming.openInterest), OIChange: Number(streaming.oiChange), OIChangePercentage: Number(streaming.oiChangePercentage) });
            }
        }
        return x;
    });
};
export const marketFutTodayStream = (data, streaming) => {
    return data.map((x) => {
        if (x.symbol) {
            if (x.symbol === streaming.symbol) {
                return Object.assign(Object.assign({}, x), { change: streaming.changePrice, changePercentage: streaming.changePercentage, stockValue: streaming.curPrice, open: streaming.open, prevClose: streaming.close, openInterest: streaming.openInterest, rollOver: streaming.rollOverCost, rollOverCost: streaming.rollOver, rollOverChangePercentage: streaming.rollOverCostPercentage, lastUpdatedTime: getDateInFormat(streaming.updatedTime, "HH:mm:ss"), 
                    //spotRate: streaming.spotPrice,
                    // volume: streaming.volume,
                    averageTradePrice: streaming.avgTradedPrice, 
                    //  volumeChangePercentage: streaming.volumeChangePercentage,
                    high: streaming.high, low: streaming.low, 
                    // oiAnalysis: streaming.openInterest,
                    oiChangePercentage: streaming.oiChangePercentage });
            }
        }
        return x;
    });
};
export const drivingMarketStream = (data, streaming) => {
    return data === null || data === void 0 ? void 0 : data.map((x) => {
        if (x.symbol) {
            if (x.symbol === streaming.symbol) {
                return Object.assign(Object.assign({}, x), { change: streaming.changePrice, changePercentage: streaming.changePercentage, lastTradedPrice: streaming.curPrice, volume: streaming.volume, rollOverPercentage: streaming.rollOver, rollOverCost: streaming.rollOverCost, rollOverCostPercentage: streaming.rollOverCostPercentage, activeValue: streaming.totalTradedValue, latestUpdatedTime: streaming.updatedTime });
            }
        }
        return x;
    });
};
